import { Component, Input, OnInit, inject } from '@angular/core';
import {SharedModalControllerService} from "@shared/services/shared-modal-controller.service";
import {IonicModule} from "@ionic/angular";
import {AsyncPipe} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SharedPinInputComponent} from "@shared/components/pin-input/shared-pin-input.component";
import {select, Store} from "@ngrx/store";
import {Observable, of} from "rxjs";
import {RegisterUserDto} from "@server-models";
import {TechRegisterState} from "@tech/pages/register/store/tech-register.state";
import {TechRegisterSelectors} from "@tech/pages/register/store/tech-register.selector-type";
import {TechRegisterActions} from "@tech/pages/register/store/tech-register.actions-type";

@Component({
  selector: 'app-tech-register-pin-form',
  templateUrl: './tech-register-pin-form.component.html',
  styleUrls: ['./tech-register-pin-form.component.scss'],
  imports: [
    IonicModule,
    TranslatePipe,
    FormsModule,
    ReactiveFormsModule,
    SharedPinInputComponent,
    AsyncPipe
],
  standalone: true
})
export class TechRegisterPinFormComponent implements OnInit {
  private _sharedModalControllerService = inject(SharedModalControllerService);
  private _store = inject<Store<TechRegisterState>>(Store);


  @Input() passwordBase64: string;
  @Input() email: string;

  pinForm: FormGroup;
  currentPin: string;
  isSubmitDisabled: boolean;
  isLoading$: Observable<boolean>;

  constructor() {
    this.passwordBase64 = "";
    this.email = "";
    this.currentPin = "";
    this.pinForm = new FormGroup({});
    this.isSubmitDisabled = true;
    this.isLoading$ = of(false);
  }

  ngOnInit() {
    this.isLoading$ = this._store.pipe(select(TechRegisterSelectors.selectIsLoading));
  }

  /**
   * @name exit
   * @description
   * close the modal
   * @memberof TechRegisterPinFormComponent
   */
  exit(): void {
    this._store.dispatch(TechRegisterActions.initRegistrationGuestDialogClose());
    this._sharedModalControllerService.closeModal();
  }

  /**
   * @name submit
   * @description
   * dispatch the action on submit to complete the invitation
   * @memberof TechRegisterPinFormComponent
   */
  submit(): void {
    const dispatchData: RegisterUserDto = {
      passwordBase64: this.passwordBase64,
      pinFromEmail: this.currentPin,
      email: this.email
    };

    this._store.dispatch(TechRegisterActions.registerGuestAsUser({ data: dispatchData, isLoadingId: this.currentPin }))
  }

  /**
   * @name formatPin
   * @description
   * format the pin to a full number as string
   * @memberof TechRegisterPinFormComponent
   * @param pinArray
   * @returns {string}
   */
  formatPin(pinArray: number[]): string {
    return parseInt(pinArray.join('')).toString();
  }

  /**
   * @name onPinFormChanged
   * @description
   * update this currentpin and form values on form change
   * @memberof TechRegisterPinFormComponent
   * @param pinForm
   */
  onPinFormChanged(pinForm: FormGroup): void {
    this.currentPin = this.formatPin(pinForm.get('pin')?.value);
    this.pinForm = pinForm;
    this.pinForm.setControl('pin', pinForm.get('pin'));
    this.isSubmitDisabled = this.pinForm.invalid;
  }

  /**
   * @name requestPinAgain
   * @description
   * make the pin request again
   * @memberof TechRegisterPinFormComponent
   */
  requestPinAgain(): void {
    this._store.dispatch(TechRegisterActions.registerGuestPinRequest({
      registerGuest: {
        isRetry: true,
        email: this.email,
        passwordBase64: this.passwordBase64
      },
      isLoadingId: this.email
    }));
  }
}
